import React, { Component } from 'react';


export default class InfoWrapper extends Component {

  constructor(props) {
    super(props);
    this.state = {
      collapsed: false
    };
    this.toggleCollapse = this.toggleCollapse.bind(this);
  }

  toggleCollapse() {
    this.setState({ collapsed: !this.state.collapsed });
  }
  
  render() {
    return (
      <div className="has-shadow nbn-infobox nbn-infobox--overlay">
        <header className={`nbn-infobox__header nbn-content-area-${ this.props.color }`} onClick={ this.toggleCollapse }>
          <div className="tablecell">
            <div className="has-margin-right-xsmall content-area-white circle nbn-circle--large"><i className={`circle__content nbn-icon--size-large fin-text-${ this.props.color } icon-${ this.props.icon }`} /></div>
          </div>
          <div className="tablecell full-width">
            <h2 className="text-uppercase no-margin weight-normal text-xx-large show fin-text-white">{ this.props.title }</h2>
            <h3 className="fin-text-white no-margin text-xx-small">{ this.props.subtitle }</h3>
          </div>
          <div className="tablecell"><i className={`icon-arrow-down icon--size-large fin-text-white ${ this.state.collapsed ? 'icon-rotate-x' : '' }`} /></div>
        </header>
        <div className={`nbn-slider ${ this.state.collapsed ? 'closed' : '' }`}>
          { this.props.children }
        </div>
      </div>
    );
  }
}
